import axiosInstance from "../config/axiosInstance";
import { ArchievedChats } from "../types/chatActions/archive";

/**
 * Archives or unarchives a chat session
 * @param sessionId ID of the session to archive or unarchive
 * @param archiveStatus 0 for archive, 1 for unarchive
 * @returns API response data
 */
const updateArchiveStatus = async (
  sessionId: string,
  archiveStatus: number
) => {
  try {
    const { data } = await axiosInstance.delete("/api/archiveSession", {
      data: { session_id: sessionId, archive_status: archiveStatus },
    });
    return data;
  } catch (error) {
    console.error("Error in updateArchiveStatus:", error);
    throw error;
  }
};

/**
 * Retrieves archived chat messages for a session
 * @param sessionId ID of the session to retrieve archived messages
 * @returns API response data
 */
const getArchivedChatSession = async (sessionId: string) => {
  try {
    const { data } = await axiosInstance.get("/api/getarchivedchatSession", {
      params: { session_id: sessionId },
    });
    return data;
  } catch (error) {
    console.error("Error retrieving archived chat session:", error);
    throw error;
  }
};

/**
 * Retrieves all archived sessions with pagination
 * @param params Object containing page and limit for pagination
 * @returns API response data
 */
const getArchivedSessions = async (params: { page: number; limit: number }) => {
  try {
    const { data } = await axiosInstance.get<{
      total: number;
      data: ArchievedChats[];
    }>("/api/getarchivedSessions", {
      params,
    });
    return data;
  } catch (error) {
    console.error("Error retrieving archived sessions:", error);
    throw error;
  }
};

/**
 * Retrieves all archived sessions with pagination
 * @param params Object containing page and limit for pagination
 * @returns API response data
 */
const getAlltArchivedSessions = async (params: {
  page: number;
  limit: number;
}) => {
  try {
    const { data } = await axiosInstance.get<{
      total: number;
      data: ArchievedChats[];
    }>("/api/getarchivedSessions", {
      params,
    });
    return { data, page: params.page };
  } catch (error) {
    console.error("Error retrieving archived sessions:", error);
    throw error;
  }
};

const unArchiveAllSessions = async () => {
  try {
    const { data } = await axiosInstance.delete(
      "/api/update/unArchiveAllSessions"
    );
    return data;
  } catch (error) {
    console.error("Error unarchiving all sessions:", error);
    throw error;
  }
};

const unArchiveChat = async (sessionId: string, archiveStatus: number) => {
  try {
    const { data } = await axiosInstance.delete("/api/archiveSession", {
      data: { session_id: sessionId, archive_status: archiveStatus },
    });
    return { data, sessionId };
  } catch (error) {
    console.error("Error in updateArchiveStatus:", error);
    throw error;
  }
};

const chatArchiveService = {
  updateArchiveStatus,
  getArchivedChatSession,
  getArchivedSessions,
  unArchiveAllSessions,
  unArchiveChat,
  getAlltArchivedSessions,
};

export default chatArchiveService;
